module.exports = __webpack_public_path__ + "img/certificate2.df9a7886.png";